import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import {
  InterfaceNameValue,
  RadioButtonGroup,
  InterfaceRadioButtonOption,
} from '@tiendanube/components';
import { PublishedType } from 'domains/Catalog/Products/productsServices';

interface OnChangeValue {
  name: string;
  value: PublishedType;
}

interface StockProps {
  value: PublishedType;
  onChange: ({ name, value }: OnChangeValue) => void;
}
function Published({ value, onChange }: StockProps): JSX.Element {
  const { t } = useTranslation([Domain.CATALOG]);

  const options: PublishedType[] = ['', 'true', 'false'];

  const labelOptions: InterfaceRadioButtonOption[] = options.map((value) => ({
    value,
    label: t(`products.filters.published.${value || 'all'}`),
  }));

  const handleChange = (data: InterfaceNameValue) => {
    onChange(data as OnChangeValue);
  };

  return (
    <RadioButtonGroup
      label={t('products.filter.published')}
      name="published"
      options={labelOptions}
      onChange={handleChange}
      value={value}
    />
  );
}

export default Published;
